import { CORE_EVENT_NAMES } from '../../../../common/support/eo_mapping';
import { CHARTS_DEFAULT_HIGH_CHART_CONFIG } from '../../../constants/analytics/charts';

export const MAX_DIMENSIONS = 1;

export const MIN_DIMENSIONS = 0;

export const DEFAULT_DATA_SOURCES = [CORE_EVENT_NAMES.INSTALL];

export const ADS_HIGH_CHART_CONFIG = {
  ...CHARTS_DEFAULT_HIGH_CHART_CONFIG,
  exporting: {
    filename: 'ads',
    chartOptions: {
      title: {
        text: 'Ads',
      },
    },
  },
};
